import { useState } from 'react';
import { DeepDiveRailWidget } from '@/core/deep-dive/widgets/deep-dive-rail-widget';

export default function useFixedSidePanelWidgets() {
  const [deepDiveWidget] = useState(() => new DeepDiveRailWidget());

  return { deepDiveWidget };
}
